export function* generateArrayEqualChunks<T>(items: T[], maxChunkSize: number): Generator<T[], void> {
  if (maxChunkSize <= 0) throw new Error('maxChunkSize must be > 0');

  const n = items.length;
  const chunksCount = n === 0 ? 0 : Math.ceil(n / maxChunkSize);

  if (chunksCount <= 0) return;

  const baseSize = Math.floor(n / chunksCount);
  const remainder = n % chunksCount;
  let start = 0;

  for (let i = 0; i < chunksCount; i++) {
    const extra = i < remainder ? 1 : 0;
    const end = start + baseSize + extra;
    yield items.slice(start, end);
    start = end;
  }
}

export function getArrayEqualChunks<T>(items: T[], maxChunkSize: number): T[][] {
  return [...generateArrayEqualChunks(items, maxChunkSize)];
}

export function filterArrayIndexes<T>(array: T[], predicate: (item: T) => boolean): number[] {
  const indexes: number[] = [];

  array.forEach((item, index) => {
    if (predicate(item)) indexes.push(index);
  });

  return indexes;
}
